import * as Yup from "yup";
import { validationErrors } from "./validationRules.js";
import validationUtils from "./validationUtils.js";

const registerSchema = Yup.object().shape({
  first_name: validationUtils?.validateName("first_name"),

  last_name: validationUtils?.validateName("last_name"),

  phone_number: validationUtils?.validatePhoneNumber(),

  email: validationUtils?.validateEmail(),

  password: validationUtils?.validatePassword(),

  confirm: Yup.string()
    .required(validationErrors?.getRequiredField("confirm password"))
    .test(
      "passwords-match",
      validationErrors?.password?.notMatch,
      function (value) {
        // Only check match if both fields have values
        return !value || this?.parent?.password === value;
      }
    ),

  captcha_value: validationUtils?.validateCaptchaValue(),
});

export default registerSchema;
